import { AppShell } from '@mantine/core';
import { Header } from '../index';
import { Outlet } from 'react-router-dom';

const MinimalLayout = () => {
    return (
        <AppShell
            header={{ height: 65 }}
            padding='md'>
            <AppShell.Header>
                <Header showDropdown={false} />
            </AppShell.Header>
            <AppShell.Main>
                <Outlet />
            </AppShell.Main>
        </AppShell>
    );
};
export default MinimalLayout;
